export default {
  audience: 'https://messeapi.sagasser.de/',
  domain: 'sagasser.eu.auth0.com',
  clientId: 'n4QseNZ7LJWvx7CG6lN3ONE3cuzdxK71',
  namespace: 'https://www.wachter.biz',
  scope: 'read:evaluations write:evaluations read:textSnippets write:textSnippets read:attachments read:customers read:discounts read:orders read:prices read:products read:quantities read:suppliers write:attachments write:customers write:discounts write:orders write:prices write:products write:quantities write:suppliers read:customEmailTemplates write:customEmailTemplates',
  signInCallbackUrl: `${process.env.VUE_APP_BASE_URL}/sign-in-callback`,
  signOutCallbackUrl: `${process.env.VUE_APP_BASE_URL}/sign-out-callback`
}